

import { Component, OnInit, ViewEncapsulation, ViewChild, TemplateRef, Input, EventEmitter, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorage, LocalStorageService } from 'ngx-store';
import { saveAs } from 'file-saver';
import { SelectionType, ColumnMode } from '@swimlane/ngx-datatable';

//Model
import { Induction } from '../../model/induction.model';
import { Url, ThemeSetting } from '../../model/users.model';
import { FileExport } from '../../model/exporter.model';

//Services
import { InductionService} from '../../services/inductions.service';
import { ExportService } from '../../services/exporter.service';
import { PrintService } from '../../services/print.service';
import { NotificationService } from '../../services/notification.service';


import { formatDate } from '@angular/common';

@Component({
    selector: 'app-inductions',
    templateUrl: './inductions.component.html',
    styleUrls: ['../datatable.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [ InductionService ],
    exportAs: 'app-inductions',

  })
  
  export class InductionsComponent implements OnInit {    
    @LocalStorage() url!: Url;
    @Output() refreshRootData : EventEmitter<any>= new EventEmitter<any>();

    public fileStoragePath = this.url.fileStorage;

    induction_rows = [];
    temp_inductions = [];
    full_induction_rows = [];

    selected = [];
    certificates = [];
    loadingIndicator: boolean = true;
    reorderable: boolean = true;
    induction_count : number;
    certificate: any;
    pending_sets =[];
    has_pending: boolean = false;
    induction_tasks = [];
    induction_done = [];
    assessment_done = [];
    current_date = new Date();
    inductions_needed = [];

    showTaskName:boolean=true;
    showTaskType:boolean=true;
    showStatus:boolean=true;
    showDateDone:boolean=true;
    showTaskExpiry:boolean=true;
    showFile:boolean=true;
    public showSidebar: boolean = true;

    showSetName:boolean=true;
    showSetDescription:boolean=true;
    showDateDone2:boolean=true;
    showTimeDone:boolean=true;
    showCertificate:boolean=true;
    showApproval:boolean=true;
    showDeclaration:boolean=true;
    showTraining:boolean=true;
    public showSidebar2: boolean = true;
    certificates_count : number;
    selected2 = [];
    current_user_id : number;

    public s_theme: ThemeSetting;
    induction_history = [];
    history_count : number;

    public folder_path :string;

    //Handles the name, type and content of the to-be exported file
    public exp_excel: FileExport;
    public exp_pdf: FileExport;

    //Stores the filtered and formatted content of the file
    formatted_list: any;

    @Input() user_id: number;
    @Input() display_name: string;
    @Input() origin: string;
    @ViewChild('modalDeleteInductionRecord', { static: false }) modalDeleteInductionRecord: TemplateRef<any>;
    @ViewChild('modalResetInduction', { static: false }) modalResetInduction: TemplateRef<any>;
    @ViewChild('modalRetrainInduction', { static: false }) modalRetrainInduction: TemplateRef<any>;
    @ViewChild('modalBulkRetrain', {static: false}) modalBulkRetrain: TemplateRef<any>;
    @ViewChild('modalReinduction', {static: false}) modalReinduction: TemplateRef<any>;

    constructor(private http: HttpClient, 
                private inductionService: InductionService,
                private modal: NgbModal,
                private exporter: ExportService,
                public printer: PrintService,
                private svc_storage: LocalStorageService,
                private toastr: NotificationService,
                ){
              
    }

    ngOnInit() {
      this.s_theme = this.svc_storage.get('themeSettings');
      this.current_user_id = this.svc_storage.get('user').id;
      this.getInductions();
      
      //Declaration to handle the name, type and content of the file
      this.exp_excel = { title: '', list_data: '', type: '' };
      this.exp_pdf = { title: '', list_data: '', type: '' };

      //main folder path
      if(this.origin == 'Administrator'){
        this.folder_path = 'user_files';
      }else{
        this.folder_path = 'drivers';
      }
    }

    columns = [
      { prop: 'set_tasks_id' },          
      { prop: 'set_tasks_title' },       
      { prop: 'set_tasks_task_type_id' },
      { prop: 'set_description' },       
      { prop: 'set_date' },              
      { prop: 'set_role' },              
      { prop: 'set_subrole_id' },        
      { prop: 'set_task_type_name' },    
      { prop: 'record_date_finish' },    
      { prop: 'record_filename' },       
      { prop: 'filename_path' },       
      { prop: 'record_status' },         
      { prop: 'record_id' },             
      ];

    columns2 = [
      { prop: 'id' },          
      { prop: 'set_id' },       
      { prop: 'induction_set_name' },
      { prop: 'role_name' },       
      { prop: 'set_date' },              
      { prop: 'time_done' },              
      { prop: 'user_id' },        
      { prop: 'induction_set_description' },    
      { prop: 'declaration_file' },    
      { prop: 'date_done' },       
      { prop: 'checklist_file' },       
      { prop: 'certificate_file' },         
      { prop: 'approval_file' },             
      ];

    onSelect({ selected }) {
      //console.log('Select Event', selected, this.selected);
      if(selected != undefined){
        this.selected = selected;
      }else{
        this.selected = [];
      }
      
      console.log('Select Event');
    }

    onSelect2({ selected2 }) {
      //console.log('Select Event', selected2, this.selected2);
      console.log('Select Event');
    }

    async getInductions (){
      this.loadingIndicator = true;
      await this.inductionService.getInductions(this.user_id).subscribe(data => {
          if(data["induction_records"].length >0){
            this.induction_rows = data["induction_records"];
            this.full_induction_rows = data["induction_records"];
            this.temp_inductions = data["induction_records"];
            this.selected = [data["induction_records"][0]];
          };

          this.getCertificates();
          this.getPendingSets();
          this.getInductionsNeeded();

          this.induction_count = 0;
          if(this.induction_rows.length > 0){
            this.induction_count = this.induction_rows.length;
          }
          this.icount = this.induction_count;

          this.getInductionTasks();
          //this.getInductionDone();

          this.history_count = 0;
          if(data["induction_history"].length >0){
            this.induction_history = data["induction_history"];
            this.history_count = this.induction_history.length;
          };

          this.mark_bulk = false;
          this.resetInductionFilters();
      });
    }

    public getInductions2 (){
      this.inductionService.getInductions(this.user_id).subscribe(data => {
        if(data["induction_records"].length >0){
          this.induction_rows = data["induction_records"];
          this.full_induction_rows = data["induction_records"];
          this.temp_inductions = data["induction_records"];
          this.selected = [data["induction_records"][0]];
        };
      });
    }

    public getInductionsNeeded(){
      this.inductionService.getInductionSetTasksNeeded(this.user_id).subscribe(data =>{
        this.inductions_needed = data["induction_set_tasks_needed"];
        
        this.inductions_needed.forEach(task=>{
          if(task.record_id == null){
            this.induction_rows.push(task); // adds task to induction_rows if doesnt exists in induction_records yet.
          }
        });
        
        if(this.induction_rows.length > 0){
          this.induction_count = this.induction_rows.length;
          this.selected = [this.induction_rows[0]];
          this.induction_rows = [...this.induction_rows];
        }
        
      })
    }

    async getInductionTasks(){
      this.loadingIndicator = true;
      await this.inductionService.getInductionTasks(this.user_id).subscribe(data =>{
        this.induction_tasks = data["induction_tasks"];
        
        this.inductionService.getCompletedInductionTasks(this.user_id).subscribe(data =>{
          this.induction_done = data["induction_done"];
          this.assessment_done = data["assessment_done"];
          
          this.loadingIndicator = true;
          var done_tasks = 0;  
          if(this.induction_tasks?.length > 0 && (this.induction_done?.length > 0 || this.assessment_done?.length > 0)){
            this.induction_tasks.forEach(task=>{
              this.assessment_done.forEach(assessment_done=>{
                if(assessment_done.set_name == task.set_name){
                  done_tasks += parseInt(assessment_done.done_set_task_count);
                }
              });
  
              this.induction_done.forEach(task_done=>{
                if(task_done.set_name == task.set_name){
                  done_tasks += parseInt(task_done.done_set_task_count);
                }
              });
  
              task.done_set_task_count = done_tasks;
              this.loadingIndicator = false;
            })
          };
          this.loadingIndicator = false;
        })
      })
    }

    async getInductionDone(){
      this.loadingIndicator = true;
      await this.inductionService.getCompletedInductionTasks(this.user_id).subscribe(data =>{
        this.induction_done = data["induction_done"];
        this.assessment_done = data["assessment_done"];
        this.mergeInductionDataProgress();
      })
    }

    async mergeInductionDataProgress(){ 
      this.loadingIndicator = true;
      var done_tasks = 0;  
      if(this.induction_tasks?.length > 0 && (this.induction_done?.length > 0 || this.assessment_done?.length > 0)){
        await this.induction_tasks.forEach(task=>{
          this.assessment_done.forEach(assessment_done=>{
            if(assessment_done.set_name == task.set_name){
              done_tasks += parseInt(assessment_done.done_set_task_count);
            }
          });

          this.induction_done.forEach(task_done=>{
            if(task_done.set_name == task.set_name){
              done_tasks += parseInt(task_done.done_set_task_count);
            }
          });

          task.done_set_task_count = done_tasks;
          this.loadingIndicator = false;
        })
      };
      
      
      setTimeout(() => { this.loadingIndicator = false; }, 1500);
    }

    
    private getCertificates(){
      this.inductionService.getCertificateFiles(this.user_id).subscribe(data=>{
        if (data["certifications"].length > 0){
          this.certificates = data["certifications"];
          this.certificate = this.certificates[0];
          this.selected2 = [data["certifications"][0]];
          this.certificates_count = this.certificates.length;
        }else{
          this.certificates = [];
          this.certificates_count = 0;
        };
      })
    }

    private getPendingSets(){
      this.inductionService.getInductionProgress(this.user_id).subscribe(data=>{
        this.pending_sets = data["progress"];
        if(this.pending_sets.length>0){
          this.pending_sets.forEach(data=>{
            if(data.finish_count != data.all_set_count){
              this.has_pending = true;
            };
          })
        }
      })
    }
    
    public resetInductionRecord(induction_record_id){
      this.inductionService.resetInductionRecord(induction_record_id).subscribe(result=>{
        this.toastr.showSuccess(result['message'], 'Reset Induction Record Success');
        this.getInductions();          
      }, error=>{
        this.toastr.showError("Please try again. There was a problem with resetting the selected induction record.", 'Reset Induction Record Error')
      })

      this.closeModal();
    }


    public retrainInductionRecord(induction_record){
      induction_record['created_by'] = this.current_user_id;
      this.inductionService.retrainInductionRecord(induction_record).subscribe(result=>{
        this.toastr.showSuccess(result['message'], 'Retrain Induction Record Success');
        this.getInductions();          
      }, error=>{
        this.toastr.showError("Please try again. There was a problem with marking the selected induction record as retrain.", 'Retrain Induction Record Error');
      })

      this.closeModal();
    }


    public formatDate(inDate: string) {
      
      let formatedDate: Date;
      
      if(inDate !== null && inDate !== '' && inDate !== '0000-00-00'){
        formatedDate = new Date(inDate.replace(/-/g, "/"));
      }
      
      return formatedDate;
    }

    public modalRef: NgbModalRef;

    public deleteObj(objToDelete) {
      objToDelete['created_by'] = this.current_user_id;
      this.inductionService.deleteInductionRecord(objToDelete).subscribe(result => {
        this.toastr.showSuccess(result['message'], 'Delete Induction Record Success');
        this.getInductions();
          
      }, error=>{
        this.toastr.showError("Please try again. There was a problem with deleting the selected induction record.", 'Delete Induction Record Error');
      })

      this.closeModal();
      this.refreshRootData.emit();
    }

    objToDelete: Induction;
    openDeleteModal(induction: Induction) {
      this.objToDelete = null;
      
      if(induction){
        this.objToDelete = induction;
      }
      this.modalRef = this.modal.open(this.modalDeleteInductionRecord, { size: 'sm'});     
    }

    objToReset: Induction;
    openResetModal(induction: Induction) {
      this.objToReset = null;

      if(induction){
        this.objToReset = induction;
      }
      this.modalRef = this.modal.open(this.modalResetInduction, { size: 'sm'});     
    }

    objToRetrain: Induction;
    openRetrainModal(induction: Induction) {
      this.objToRetrain = null;

      if(induction){
        this.objToRetrain = induction;
      }
      this.modalRef = this.modal.open(this.modalRetrainInduction, { size: 'sm'});     
    }

    public closeModal(){
      this.modalRef.close();
      //this.getInductions();
    }

    public checkStatus(induction: Induction){
      var expiry = null;
      var date_finish = null;
      var status = 'COMPLETED';
      
      if (induction.record_expiry != null && induction.record_expiry != '' && induction.record_expiry != 'No Date'){
        expiry = new Date(induction.record_expiry);
      }
      if (induction.record_date_finish != null && induction.record_date_finish != '' && induction.record_date_finish != 'No Date'){
        
        date_finish = new Date(induction.record_date_finish);
        if(expiry!=null){
          if(expiry.getTime() <= this.current_date.getTime() ){
          status = 'EXPIRED';}
        }
      }else{
        status= 'PENDING';
      }

     
      if(status == 'COMPLETED' && induction.set_tasks_task_type_id == 4){ 
        if(induction.score_status != 1){
          status = 'COMPLETED-FAILED';
        }else{
          status = 'COMPLETED-PASSED';
        }
      }

      return status;

    }

    toggleSideBar() {
      if (this.showSidebar == true) {
        this.showSidebar = false;
      } else {
        this.showSidebar = true;
      }
      this.getInductions2();
    }

     /*** Export... Module ***/
    //Replaces an attribute name for reading comprehension
    renameKey(obj, oldKey, newKey) {
      obj[newKey] = obj[oldKey];
      delete obj[oldKey];
    }

    //Formats readable header names in the given table
    generateHeaders(list_inductions, caller): any {
      const arr = JSON.parse(list_inductions);

      if(caller == 'inductions'){
        arr.forEach(obj => {
          this.renameKey(obj, 'set_tasks_title', 'Task Name');
          this.renameKey(obj, 'set_task_type_name', 'Task Type');
          this.renameKey(obj, 'record_date_finish', 'Date Done');
          this.renameKey(obj, 'record_expiry', 'Task Expiry');
          this.renameKey(obj, 'record_filename', 'File');
          this.renameKey(obj, 'record_status', 'Status');
        });
      }

      if(caller == 'certificates'){
        arr.forEach(obj => {
          this.renameKey(obj, 'induction_set_name', 'Induction Set Name');
          this.renameKey(obj, 'induction_set_description', 'Description');
          this.renameKey(obj, 'date_done', 'Date Done');
          this.renameKey(obj, 'time_done', 'Time Done');
          this.renameKey(obj, 'certificate_file', 'Certificate File');
          this.renameKey(obj, 'approval_file', 'Approval Letter');
          this.renameKey(obj, 'declaration_file', 'Responsibility Statement');
          this.renameKey(obj, 'checklist_file', 'Training Checklist');
          
        });
      }
      
      const updatedJson = JSON.stringify(arr);
      return updatedJson;
    }

    //Filters every column in the table list
    generateColumnsWithFilter(list_inductions, caller) {
      const arr = JSON.parse(JSON.stringify(list_inductions));

      if(caller == 'inductions'){
        arr.forEach(obj => {

          // format date
          if (obj['record_date_finish'] == '0000-00-00 00:00:00' || obj['record_date_finish'] == null || obj['record_date_finish'] == "")
            obj['record_date_finish'] = 'No Date';
          else
            obj['record_date_finish'] = formatDate(obj['record_date_finish'], 'dd MMM yyyy', 'en_US');
  
          if (obj['record_expiry'] == '0000-00-00 00:00:00' || obj['record_expiry'] == null || obj['record_expiry'] == "")
            obj['record_expiry'] = 'No Date';
          else
            obj['record_expiry'] = formatDate(obj['record_expiry'], 'dd MMM yyyy', 'en_US');
                  
          //remove filtered columns
          if (!this.showTaskName) {
            delete obj['set_tasks_title'];
          };
          if (!this.showTaskType) {
            delete obj['set_task_type_name'];
          };
          if (this.showStatus) {
            let induction = new Induction();
            induction = obj;
            obj['record_status'] = this.checkStatus(induction);
          }else{
            delete obj['record_status'];
          };
          if (!this.showDateDone) {
            delete obj['record_date_finish'];
          };
          if (!this.showTaskExpiry) {
            delete obj['record_expiry'];
          };
          if (!this.showFile) {
            delete obj['record_filename'];
          };
          
          
          delete obj['filename_path'];
          delete obj['record_id'];
          delete obj['set_date'];
          delete obj['set_description'];
          delete obj['set_id'];
          delete obj['set_role'];
          delete obj['set_subrole_id'];
          delete obj['set_tasks_id'];
          delete obj['set_tasks_task_type_id'];
          delete obj['user_id'];
          delete obj['score_status'];
          delete obj['date_started'];
          delete obj['date_finish'];
          delete obj['time_started'];
          delete obj['time_finish'];
        });
      }

      if(caller == 'certificates'){
        arr.forEach(obj => {
          delete obj['user_id'];
          delete obj['updated_at'];
          delete obj['role_name'];
          delete obj['induction_set_id'];
          delete obj['id'];
          delete obj['created_at'];

          // format date
          if (obj['date_done'] == '0000-00-00 00:00:00' || obj['date_done'] == null || obj['date_done'] == "")
            obj['date_done'] = 'No Date';
          else
            obj['date_done'] = formatDate(obj['date_done'], 'dd MMM yyyy', 'en_US');
  
          //remove filtered columns
          if (!this.showSetName) {
            delete obj['induction_set_name'];
          };
          if (!this.showSetDescription) {
            delete obj['induction_set_description'];
          };
          if (!this.showDateDone2) {
            delete obj['date_done'];
          };
          if (!this.showTimeDone) {
            delete obj['time_done'];
          };
          if (!this.showCertificate) {
            delete obj['certificate_file'];
          };
          if (!this.showApproval) {
            delete obj['approval_file'];
          };
          if (!this.showDeclaration) {
            delete obj['declaration_file'];
          };
          if (!this.showTraining) {
            delete obj['certificate_file'];
          };
        });
      }
     
      const updatedJson = JSON.stringify(arr);
      return updatedJson;
    }

    //Exports  table to CSV file
    exportToCSV(caller, list) {
      if (list.length > 0) {
        let with_header_format, with_column_filter;

        //generate json with filtered column
        with_column_filter = this.generateColumnsWithFilter(list, caller);

        //generate json with format header
        this.formatted_list = this.generateHeaders(with_column_filter, caller);

        //export to file
        let current_date = new Date();
        let title = '';
        let csv_title = '';
        if(caller == 'inductions'){
          title = '[TMS]' +  this.origin +'_Inductions_';
          csv_title = 'TMS ' +  this.origin +' Inductions';
        };

        if(caller == 'certificates'){
          title = '[TMS]' +  this.origin +'_Certificates_';
          csv_title = 'TMS ' +  this.origin +' Certificates';
        };

        let csv_file = title  + this.formattedDate(current_date);
        this.exporter.exportToCSV(this.formatted_list, csv_file, csv_title);
      }
    };

    //Exports table to PDF file
    exportToPDF(caller, list) {
      if (list.length > 0) {
        let with_header_format, with_column_filter;

        //generate json with filtered column
        with_column_filter = this.generateColumnsWithFilter(list, caller);

        //generate json with format header
        this.formatted_list = this.generateHeaders(with_column_filter, caller);

        //export to file
        let current_date = new Date();
        let title = '';
        let pdf_title = '';
        if(caller == 'inductions'){
          title = '[TMS]' +  this.origin +'_Inductions_';
          pdf_title = this.origin +' Inductions';
        };

        if(caller == 'certificates'){
          title = '[TMS]' +  this.origin +'_Certificates_';
          pdf_title = this.origin +' Certificates';
        };

        let pdf_file = title + this.formattedDate(current_date);
        this.exp_pdf.title = pdf_title;
        this.exp_pdf.type = 'pdf';
        this.exp_pdf.list_data = this.formatted_list;
        this.exporter.exportToPDF(this.exp_pdf).subscribe(data => {
          saveAs(data, pdf_file + '.' + this.exp_pdf.type);
        });
      }
    };

    //Exports table to MS Excel file
    exportToExcel(caller, list) {
      if (list.length > 0) {
        let with_header_format, with_column_filter;

        //generate json with filtered column
        with_column_filter = this.generateColumnsWithFilter(list, caller);

        //generate json with format header
        this.formatted_list = this.generateHeaders(with_column_filter, caller);

        //export to file
        let current_date = new Date();
        let title = '';
        let excel_title = '';
        if(caller == 'inductions'){
          title = '[TMS]' +  this.origin +'_Inductions_';
          excel_title = this.origin +' Inductions';
        };

        if(caller == 'certificates'){
          title = '[TMS]' +  this.origin +'_Certificates_';
          excel_title = this.origin +' Certificates';
        };

        let excel_file = title + this.formattedDate(current_date);
        this.exp_excel.title = excel_title;
        this.exp_excel.type = 'xlsx';
        this.exp_excel.list_data = this.formatted_list;
        this.exporter.exportToExcel(this.exp_excel).subscribe(data => {
          saveAs(data, excel_file)
        });
      }
    };

    //Returns a date format in the file name
    public formattedDate(d = new Date) {
      let month = String(d.getMonth() + 1);
      let day = String(d.getDate());
      const year = String(d.getFullYear());

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      return `${day}/${month}/${year}`;
    }

    setProgressValue(item){
      let percentage = 0;
     
      percentage  = (item.done_set_task_count / item.set_task_count) * 100;
      
      if (percentage == 0) percentage = 100;
      
      var p = percentage.toString() + '%';
      const styles = { 'width': p };
      return styles;
    }


    toggleSideBar2() {
      if (this.showSidebar2 == true) {
        this.showSidebar2 = false;
      } else {
        this.showSidebar2 = true;
      }
      this.getCertificates();
    }

    showFilters: boolean = false;
    public toggleFilters() {
      if (this.showFilters) this.showFilters = false;
      else this.showFilters = true;
    }

    //Filter Content in Specified Column
    public icount: number = 0;
    public filterTaskTitle: string = '';
    public filterTaskType: string = '';
    public filterStatus: string = '';
    public filterFile: string = '';

    updateFilter() {
      this.temp_inductions = this.full_induction_rows;
  
      if (this.filterTaskTitle) {
        this.temp_inductions = this.temp_inductions.filter(data => {
          if (data.set_tasks_title)
            return data.set_tasks_title.toLowerCase().indexOf(this.filterTaskTitle.toLowerCase()) !== -1 || !this.filterTaskTitle.toLowerCase();
          else return data.set_tasks_title;
        });
      }

      if (this.filterTaskType) {
        this.temp_inductions = this.temp_inductions.filter(data => {
          if (data.set_task_type_name)
            return data.set_task_type_name.toLowerCase().indexOf(this.filterTaskType.toLowerCase()) !== -1 || !this.filterTaskType.toLowerCase();
          else return data.set_task_type_name;
        });
      }

      if (this.filterStatus) {
        this.temp_inductions = this.temp_inductions.filter(data => {
          if (this.checkStatus(data))
            return this.checkStatus(data).toLowerCase().indexOf(this.filterStatus.toLowerCase()) !== -1 || !this.filterStatus.toLowerCase();
          else return this.checkStatus(data);
        });
      }

      if (this.filterFile) {
        this.temp_inductions = this.temp_inductions.filter(data => {
          if (data.record_filename)
            return data.record_filename.toLowerCase().indexOf(this.filterFile.toLowerCase()) !== -1 || !this.filterFile.toLowerCase();
          else return data.record_filename;
        });
      }
  
      this.induction_rows = this.temp_inductions;
      
      if(this.temp_inductions.length){
        this.icount = this.temp_inductions.length;
        this.selected = [this.temp_inductions[0]];
      }else{
        this.icount = 0;
        this.selected = [];
      }
      
    }
  
    resetInductionFilters() {
      this.sType =  this.SelectionType.single;
      this.induction_rows = this.full_induction_rows;
      this.selected = [this.induction_rows[0]];
        
      if(this.full_induction_rows?.length){
        this.icount = this.full_induction_rows?.length
      }else{
        this.icount = 0;
      };
  
      this.filterTaskTitle = '';
      this.filterTaskType = '';
      this.filterStatus = '';
      this.filterFile = '';

      this.mark_bulk = false;
      //this.showSidebar = true;
      this.resetBulkRetrainVariables();
    }
    
    SelectionType = SelectionType;
    sType: any = this.SelectionType.single;
    mark_bulk: boolean = false;

    bulkRetrain(){
      this.resetInductionFilters();
      this.mark_bulk = true;
      this.showSidebar = false;
      this.filterStatus = 'Completed';
      this.updateFilter();
      this.updateNegateFilterByTaskType('Document Upload');
      this.filterByRecordStatusZero();
      this.filterAssessmentByScore(1);
      this.sType =  this.SelectionType.checkbox;
    }

    updateNegateFilterByTaskType(type_name){
      this.temp_inductions = this.temp_inductions.filter(data => {
        if (data.set_task_type_name)
          return data.set_task_type_name.toLowerCase() != type_name.toLowerCase();
        else return data.set_task_type_name;
      });

      this.induction_rows = this.temp_inductions;
      
      if(this.temp_inductions.length){
        this.icount = this.temp_inductions.length;
        this.selected = [this.temp_inductions[0]];
      }else{
        this.icount = 0;
        this.selected = [];
      }
    }

    filterByRecordStatusZero(){
      this.temp_inductions = this.temp_inductions.filter(data => {return data.record_status == 0});
      this.induction_rows = this.temp_inductions;
      
      if(this.temp_inductions.length){
        this.icount = this.temp_inductions.length;
        this.selected = [this.temp_inductions[0]];
      }else{
        this.icount = 0;
        this.selected = [];
      }
    }

    filterAssessmentByScore(score){
      this.temp_inductions = this.temp_inductions.filter(data => {
        if(data.record_status == 0 && data.set_tasks_task_type_id == 4){
          return data.score_status == score;
        }else{
          return data;
        }
        
      });
      this.induction_rows = this.temp_inductions;
      
      if(this.temp_inductions.length){
        this.icount = this.temp_inductions.length;
        this.selected = [this.temp_inductions[0]];
      }else{
        this.icount = 0;
        this.selected = [];
      }
    }

    getCheckboxStatus({ row, column, value }): any {
      let rCheckbox = false;
        if(row.record_id != '' && row.record_id != null){
          rCheckbox = true;
        };
        return rCheckbox
    }

    
    getCellClass({ row, column, value }): any {
      return 'is-dispatched';
    }

    bulk_count: number = 0;
    selected_bulk_retrain: any = [];

    openModalBulkMarkForRetrain(){
      this.modalRef = this.modal.open(this.modalBulkRetrain, {container: '.app', backdrop: 'static', size: 'md'});
      if(this.selected.length){
        this.selected.forEach(item=>{
          if(item.record_id != null && item.record_id !=''){
            this.selected_bulk_retrain.push(item);
          }
        })
        if(this.selected_bulk_retrain.length){
          this.bulk_count = this.selected_bulk_retrain.length;
        }
      }else{
        this.bulk_count = 0;
      }
    }

    resetBulkRetrainVariables(){
      this.selected_bulk_retrain = [];
      this.bulk_count = 0;
    }

    bulkRetrainInduction(){
      this.inductionService.bulkMarkForRetrain(this.selected_bulk_retrain, this.current_user_id).subscribe(data=>{
        if(data['error']== false){
          this.toastr.showSuccess(data['message'], '');
        }else{
          this.toastr.showError(data['message'], '');
        };
  
        this.getInductions();
      })
  
      this.modalRef.close();
      this.resetBulkRetrainVariables();
  }


  openModalReinduction(){
    this.modalRef = this.modal.open(this.modalReinduction, {container: '.app', backdrop: 'static', size: 'sm'});
  }

  markUserReinduction(){
    if(this.induction_tasks?.length >0){
      let reinduction_data;
      reinduction_data = {set_id:this.induction_tasks[0].set_id, user_id:this.user_id, created_by: this.current_user_id, set_title: this.induction_tasks[0].set_name};
      
      this.inductionService.reinductionByUserId(reinduction_data).subscribe(data=>{
        if(data['error']== false){
          this.toastr.showSuccess(data['message'], '');
        }else{
          this.toastr.showError(data['message'], '');
        };

        this.getInductions();
      })
    }
    
  }

  onTabSelectChange(event){
    switch (event){
      case 'records': {this.getInductions2();break;}
      case 'certificates': {this.getCertificates();break;}
      default:break;
    }
  }
}